import React, { useContext, useRef } from 'react';

import ReactDOM from 'react-dom';
import ReactFocusLock from 'react-focus-lock';
import { CSSTransition } from 'react-transition-group';

import { getOverlayElementRoot } from 'common/helpers/domHelpers';

import { OfflineStateContext } from './context';
import OfflineStateMessage from './OfflineStateMessage/OfflineStateMessage';

export default function OfflineStateRenderer() {
  const portalContainer = useRef(getOverlayElementRoot('offline-state'));

  const context = useContext(OfflineStateContext);

  return ReactDOM.createPortal(
    <ReactFocusLock autoFocus={context.isOffline}>
      <CSSTransition
        in={context.isOffline}
        timeout={400}
        classNames="offline-state-message"
        unmountOnExit={true}
        appear={true}
      >
        <OfflineStateMessage />
      </CSSTransition>
    </ReactFocusLock>,
    portalContainer.current!
  );
}
